
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/[slug]",
      function () {
        return require("private-next-pages/podcasts/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/[slug]"])
      });
    }
  